import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=37be1c43&scoped=true&"
import script from "./searchBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./searchBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=37be1c43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37be1c43",
  null
  
)

export default component.exports